import { render, staticRenderFns } from "./CopyLinkedTextsDialog.vue?vue&type=template&id=057a7cde&scoped=true&"
import script from "./CopyLinkedTextsDialog.vue?vue&type=script&lang=ts&"
export * from "./CopyLinkedTextsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CopyLinkedTextsDialog.vue?vue&type=style&index=0&id=057a7cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057a7cde",
  null
  
)

export default component.exports